import { format, isValid, parse } from "date-fns";
import { enGB } from "date-fns/locale";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import JSZip from "jszip";
import { saveAs } from "file-saver";

dayjs.extend(utc);
dayjs.extend(timezone);

export const convertDateFormat = (dateString, formatNeeded) => {
  const formattedDate = format(new Date(dateString), formatNeeded);
  return formattedDate;
};

export const parseDateFormat = (dateString, formatNeeded) => {
  if (isValid(new Date(dateString))) {
    const formattedDate = format(new Date(dateString), formatNeeded);
    return formattedDate;
  } else {
    const parsedDate = parse(dateString, "P", new Date(), { locale: enGB });
    const formattedDate = format(parsedDate, formatNeeded);
    return formattedDate;
  }
};

export const customformatDate = (dateString, formatNeeded) => {
  const parsedDate = parse(dateString, "EEEE, dd/MM/yyyy", new Date());
  const formattedDate = format(parsedDate, formatNeeded);
  return formattedDate;
};

//
export const convertToNumber = (value) => {
  const parsedValue = parseFloat(value);
  return isNaN(parsedValue) ? value : parsedValue;
};

export const getDayFromString = (value) => {
  const date = new Date(value);
  const day = date.toLocaleDateString("en-US", { weekday: "long" });
  return day;
};

export const convertTimeSlot = (timeSlot24hr) => {
  if (timeSlot24hr.length) {
    let timeParts = timeSlot24hr.split("-");
    let startTime = timeParts[0].trim();
    let endTime = timeParts[1].trim();
    let startTimeParts = startTime.split(":");
    let startHours = parseInt(startTimeParts[0]);
    let startMinutes = parseInt(startTimeParts[1]);

    let endTimeParts = endTime.split(":");
    let endHours = parseInt(endTimeParts[0]);
    let endMinutes = parseInt(endTimeParts[1]);

    let startMeridiem = startHours < 12 ? "AM" : "PM";
    let endMeridiem = endHours < 12 ? "AM" : "PM";

    if (startHours === 0) {
      startHours = 12;
    } else if (startHours > 12) {
      startHours -= 12;
    }

    if (endHours === 0) {
      endHours = 12;
    } else if (endHours > 12) {
      endHours -= 12;
    }

    let convertedTimeSlot =
      startHours +
      ":" +
      (startMinutes < 10 ? "0" + startMinutes : startMinutes) +
      startMeridiem +
      " - " +
      endHours +
      ":" +
      (endMinutes < 10 ? "0" + endMinutes : endMinutes) +
      endMeridiem;

    return convertedTimeSlot;
  }
};

export const validateAbhaAddress = (address) => {
  // const regex = /^[A-Za-z0-9]+([_.][A-Za-z0-9]+)*$/;
  return (
    // /^[\w!@#$%^&*-_./?]{8,18}$/.test(address)
    // /^[a-zA-Z0-9](?=.*[a-zA-Z0-9!@#$%^&*._])([a-zA-Z0-9!@#$%^&*._]{6,18}[a-zA-Z0-9])$/.test(address)
    // /^(?=.*[A-Za-z])(?=.*\d)(?!.*[_\.]{2})[A-Za-z\d](?=.*[_\.])[A-Za-z\d_\.]{6,16}[A-Za-z\d]$/.test(address)
    /^(?=.*[A-Za-z])(?=.*\d)(?!.*[_\.]{2})[A-Za-z\d]([A-Za-z\d_\.]{6,16})?[A-Za-z\d]$/.test(
      address
    )
  );
};

export const calculateBMI = (bodyHeight, bodyWeight) => {
  // Check if bodyHeight and bodyWeight are numbers
  const height = Number(bodyHeight);
  const weight = Number(bodyWeight);
  if (
    typeof height !== "number" ||
    isNaN(height) ||
    typeof weight !== "number" ||
    isNaN(weight)
  ) {
    console.error(
      "Invalid input. Please enter valid numbers for body height and weight."
    );
    return null;
  }

  const bodyHeightM = height / 100;
  const bmi = weight / Math.pow(bodyHeightM, 2);
  return bmi;
};

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64Data = reader.result.split(",")[1];
      resolve(base64Data);
    };
    reader.onerror = (error) => reject(error);
  });
};

export const base64ToFile = (base64String, filename, mimeType) => {
  // Remove quotes from the beginning and end of the base64 string

  const cleanedBase64String = base64String?.replace?.(/^"|"$/g, "");

  const byteString = atob?.(cleanedBase64String);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  const blob = new Blob([uint8Array], { type: mimeType });
  const file = new File([blob], filename, { type: mimeType });
  return file;
};

export const convertDateFormatInUtc = (dateString, format) => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return dayjs.utc(dateString).tz(userTimezone).format(format);
};

export const addHoursUtc = (dateString, hours = 48) => {
  if (!dateString) return null;
  const date = dayjs.utc(dateString);
  return date.isValid() ? date.add(hours, "hour").toISOString() : null;
};

export const subtractHoursUtc = (dateString, hours = 48) => {
  if (!dateString) return null;
  const date = dayjs.utc(dateString);
  return date.isValid() ? date.subtract(hours, "hour").toISOString() : null;
};

export const getDeadlineInfo = (dateString, hours = 48) => {
  const deadline = addHoursUtc(dateString, hours);
  if (!deadline) return null;

  const deadlineDate = dayjs.utc(deadline);
  const remainingHours = deadlineDate.diff(dayjs(), "hour", true);

  if (remainingHours <= 0) {
    return {
      deadline,
      label: "Past 48h",
      tone: "danger",
      isPastDue: true,
    };
  }

  if (remainingHours <= 24) {
    return {
      deadline,
      label: "Due today",
      tone: "warning",
      isPastDue: false,
    };
  }

  return {
    deadline,
    label: `${Math.ceil(remainingHours)}h left`,
    tone: "success",
    isPastDue: false,
  };
};

// A pending shipment must ship within 48h of reaching Pending Shipment: the
// label upload for Sell shipments, or the status change / creation time for
// Ship Direct shipments (created straight into Pending Shipment, no label).
export const getShipmentDeadlineInfo = (shipment) =>
  shipment?.status === "PENDING_SHIPMENT"
    ? getDeadlineInfo(
        shipment?.label_upload_date || shipment?.status_updated_at || shipment?.created_at
      )
    : null;

export const convertDateToCT = (dateString, format) => {
  const centralTimeZone = "America/Chicago";
  return dayjs.utc(dateString).tz(centralTimeZone).format(format);
};

export function downloadDocument(
  documentBytes,
  fileName,
  mimeType = "application/octet-stream"
) {
  const byteCharacters = atob(documentBytes);
  const byteNumbers = new Array(byteCharacters.length)
    .fill(0)
    .map((_, i) => byteCharacters.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);

  const blob = new Blob([byteArray], { type: mimeType });

  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);

  a.click();

  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function downloadMultipleFiles(files, baseFileName) {
  try {
    // Create a new array to store all files as individual blobs
    const blobs = files.map((item, index) => {
      const byteCharacters = atob(item.document_bytes);
      const byteArray = new Uint8Array(
        new Array(byteCharacters.length)
          .fill(0)
          .map((_, i) => byteCharacters.charCodeAt(i))
      );

      return new Blob([byteArray], { type: item.content_type });
    });

    // If there's only one blob, download it directly
    if (blobs.length === 1) {
      const url = URL.createObjectURL(blobs[0]);
      const link = document.createElement("a");
      link.href = url;
      link.download = baseFileName;
      link.click();
      URL.revokeObjectURL(url);
    }
    // For multiple blobs, try to download them sequentially
    else {
      blobs.forEach((blob, index) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${baseFileName}_${index + 1}`;

        // Add a small delay between downloads
        setTimeout(() => {
          link.click();
          URL.revokeObjectURL(url);
        }, index * 100);
      });
    }
  } catch (error) {
    console.error("Error downloading files:", error);
  }
}

export const formatNumberToDollar = (number = 0) => {
  if (number === null || typeof number !== "number") {
    number = 0;
  }
  const formattedNumber = number.toLocaleString("en-US");
  return `$${formattedNumber}`;
};

export const countActiveFilters = (...filterGroups) =>
  filterGroups
    .flatMap((group) => (Array.isArray(group) ? group : []))
    .filter((value) => {
      if (value === null || value === undefined) return false;
      const normalized = String(value).trim().toLowerCase();
      return normalized !== "" && normalized !== "null" && normalized !== "undefined";
    }).length;

export const countActiveFiltersAndSort = (sortDirection, ...filterGroups) =>
  countActiveFilters(...filterGroups) +
  (sortDirection && sortDirection !== "null" && sortDirection !== "undefined" ? 1 : 0);

export function downloadImagesAsZip(files, baseFileName = "images") {
  try {
    const zip = new JSZip();

    files.forEach((file, index) => {
      const byteCharacters = atob(file.document_bytes || file.image_data); // Decode base64
      const byteArray = new Uint8Array(
        new Array(byteCharacters.length)
          .fill(0)
          .map((_, i) => byteCharacters.charCodeAt(i))
      );
      const blob = new Blob([byteArray], {
        type: file.content_type || file.image_type,
      });

      // Determine file extension
      const extension =
        (file.content_type || file.image_type).split("/")[1] || "file";

      zip.file(`${baseFileName}_${index + 1}.${extension}`, blob);
    });

    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, `${baseFileName}_document.zip`);
    });
  } catch (error) {
    console.error("Error downloading files:", error);
  }
}
